'use client';

import type { AnswerValue } from '@repo/contracts/cardfinder/funnel/types';
import { createContext } from 'react';
import type { AnswerStore } from './types';

export type AnswerStoreContextValue = {
  store: AnswerStore;
  setAnswer: (stepId: string, value: AnswerValue) => void;
  clearAnswer: (stepId: string) => void;
};

export const AnswerStoreContext = createContext<AnswerStoreContextValue | undefined>(undefined);
